import React from 'react';
import { Sun, Moon } from 'lucide-react';

// Botón discreto de claro/oscuro. El estado lo maneja quien lo usa.
export default function ThemeToggle({ theme, onChange, color }) {
  const oscuro = theme !== 'light';
  return (
    <button
      type="button"
      onClick={() => onChange(oscuro ? 'light' : 'dark')}
      title={oscuro ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}
      aria-label={oscuro ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}
      style={{
        background: 'transparent', border: 'none', cursor: 'pointer', padding: 6, borderRadius: 8,
        color: color || 'var(--text-muted)', display: 'inline-flex', alignItems: 'center',
      }}
    >
      {oscuro ? <Sun size={17} /> : <Moon size={17} />}
    </button>
  );
}
